<template>
  <v-card>
    <!-- tab control -->
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">Solicitudes de Liquidación de Comisiones</div>
      <div>
        <v-tabs v-model="currentTab">
          <v-tab :disabled="editMode === 'edit' || editMode === 'new'">
            Lista
          </v-tab>
          <v-tab :disabled="!currentItem">Edición</v-tab>
        </v-tabs>
      </div>
      <div v-show="currentTab === 1">
        <v-btn
          v-show="editMode !== 'show'"
          color="warning"
          outlined
          @click="cancel"
          class="mx-2"
        >
          Cancelar
        </v-btn>
        <v-btn
          v-show="editMode === 'show' && canEdit"
          color="success"
          outlined
          @click="edit"
          class="mx-2"
        >
          Editar
        </v-btn>
        <v-btn
          v-show="editMode !== 'show'"
          :disabled="onAction == true"
          color="success"
          outlined
          @click="save"
          class="mx-2"
        >
          Guardar
        </v-btn>
        <v-btn
          v-show="editMode == 'show' && canRequestInvoicing"
          :disabled="onAction == true"
          color="success"
          outlined
          @click="requestInvoicing"
          class="mx-2"
        >
          Solicitar Orden de Compra
        </v-btn>
        <v-btn
          v-show="editMode == 'show' && canArchive"
          :disabled="onAction == true"
          color="warning"
          outlined
          @click="archive"
          class="mx-2"
        >
          Anular Solicitud
        </v-btn>
        <v-btn
          v-if="false"
          v-show="editMode == 'show' && canUnarchive"
          color="warning"
          outlined
          @click="unarchive"
          class="mx-2"
        >
          Desarchivar
        </v-btn>
      </div>
    </v-card>
    <!-- tab0 list -->
    <v-card-text v-show="currentTab === 0">
      <v-card>
        <!-- advanced filter -->
        <v-toolbar>
          <v-autocomplete
            label="Agente"
            :items="dealerItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="name"
            item-value="url"
            v-model="selectedDealer"
            return-object
            @change="dealerSelected($event)"
            ref="dealerAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('dealerAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Estado"
            :items="stateItems"
            :loading="isLoadingState"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            return-object
            @change="stateSelected($event)"
            @click:prepend="clearAutocomplete('stateAutocomplete')"
            ref="stateAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-menu
            :ref="'date_from'"
            v-model="showPicker_from"
            :close-on-content-click="false"
            :return-value.sync="date_from"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                dense
                :hide-details="true"
                :single-line="true"
                v-model="date_from_formatted"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date_from" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="showPicker_from = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="dateFromEntered()">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-toolbar>
        <!-- table header pagination and add button -->
        <div class="table-footer-prepend d-flex pl-2 align-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                :disabled="!enableEditing"
                icon
                outlined
                color="primary"
                class="mr-3"
                v-on="on"
                @click="addNew()"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Agregar Solicitud</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                outlined
                color="primary"
                class="mr-3"
                v-on="on"
                @click="readDataFromAPI()"
              >
                <v-icon>mdi-sync</v-icon>
              </v-btn>
            </template>
            <span>Actualizar</span>
          </v-tooltip>
        </div>
        <!-- data table -->
        <v-data-table
          dense
          v-bind:page="page"
          :pageCount="this.pageCount"
          :loading="loading"
          :headers="headers"
          :items="items"
          :itemsPerPage="itemsPerPage"
          :serverItemsLength="serverItemsLength"
          :options.sync="options"
          :canViewDocument="true"
          @click:row="itemSelected($event, false)"
        >
          <template v-slot:top="{ options, updateOptions }">
            <div class="table-footer-append d-flex align-center justify-end">
              <span class="mr-2">{{ getPaginationSummary() }}</span>
              <v-btn
                icon
                small
                class="mr-1"
                :disabled="page <= 1"
                @click="updateOptions(Object.assign({}, options, { page: 1 }))"
              >
                <v-icon>mdi-page-first</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                class="mr-1"
                :disabled="page <= 1"
                @click="updateOptions(Object.assign({}, options, { page: page - 1 }))"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                class="mr-1"
                :disabled="page >= pageCount"
                @click="updateOptions(Object.assign({}, options, { page: page + 1 }))"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                class="ml-0"
                :disabled="page >= pageCount"
                @click="updateOptions(Object.assign({}, options, { page: pageCount }))"
              >
                <v-icon>mdi-page-last</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.visual_state`]="{ item }">
            <v-icon small class="mr-2">
              {{ item.state_icon }}
            </v-icon>
            <span>{{ item.state_description }} </span>
          </template>
          <template v-slot:[`item.observations`]="{ item }">
            <span>{{ getObservationText(item) }} </span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              @click.stop="viewDocumentItem(item)"
              :disabled="!item.invoice"
            >
              mdi-eye-outline
            </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-card-text>
    <!-- tab1 edit pedido -->
    <div v-if="currentTab === 1">
      <settlement-request-edit
        :initialmode="editMode"
        :value="currentItem"
        :key="currentTab"
        ref="itemEdit"
        @endEdit="endEdit"
        @actionCanceled="actionCanceled"
      >
      </settlement-request-edit>
    </div>
  </v-card>
</template>
<script>
import SettlementRequest from "@/components/clon/DataSettlementRequest.js";
import SettlementRequestEdit from "@/components/SettlementRequestEdit.vue";
import XLSX from "xlsx";

export default {
  name: "SettlementRequest",

  components: {
    SettlementRequestEdit
  },

  data() {
    return {
      currentTab: 0,
      editMode: "show",
      defaultOrder: "-backend_code",
      currentItem: null,
      stateItems: [],
      dealerItems: [],
      lastEndpoint: null,
      selectedDealer: null,
      isLoadingState: false,
      filterState: null,
      filterDealer: null,
      showPicker_from: false,
      // eslint-disable-next-line
      date_from: this.$moment().subtract(3, 'months').format("YYYY-MM-DD"),
      date_from_formatted: this.formatDate(this.date_from),
      loading: true,
      mounting: true,
      page: 1,
      serverItemsLength: 0,
      pageCount: 0,
      itemsPerPage: 20,
      options: {},
      items: [],
      settlementRequest: new SettlementRequest(this.$bRoot),
      enableEditing: false,
      canEdit: false,
      canRequestInvoicing: false,
      canArchive: false,
      canUnarchive: false,
      onAction: false,
      headers: [
        { text: "id", value: "id", sortable: false },
        { text: "Fecha", value: "date_formatted", sortable: false },
        {
          text: "Usuario",
          value: "commercial_person_name",
          sortable: false,
          width: "10%"
        },
        {
          text: "Agente",
          value: "dealer_name",
          sortable: false,
          width: "20%"
        },
        {
          text: "Comisión Total USD",
          value: "total_commission_usd",
          sortable: false,
          align: "right",
          width: "10%"
        },
        {
          text: "Comisión Total PES",
          value: "total_commission_lc",
          sortable: false,
          align: "right",
          width: "10%"
        },
        {
          text: "Observaciones",
          value: "observations",
          width: "15%",
          sortable: false
        },
        {
          text: "Estado",
          value: "visual_state",
          sortable: false,
          width: "15%"
        },
        {
          text: "Registración",
          value: "backend_code",
          sortable: false
        },
        { text: "Acciones", value: "actions", sortable: false }
      ],
      canDelete: false,
      downloading: false
    };
  },

  //this one will populate new data set when user changes current page.
  watch: {
    options: {
      handler(options) {
        let order_by = "";
        let order_desc = 0;

        if (options.sortBy.length > 0) {
          order_by = options.sortBy[0];
          order_desc = options.sortDesc[0] ? 1 : 0;
        } else {
          order_by = this.defaultOrder;
          order_desc = 0;
        }
        this.readDataFromAPI(false, order_by, order_desc);
      }
    },
    deep: true
  },

  methods: {
    //Reading data from API method.
    async readDataFromAPI(reset, order_by, order_desc) {
      if (!this.mounting) {
        try {
          this.loading = true;
          this.items = [];
          if (!order_by) {
            order_by = this.defaultOrder;
          } else {
            order_by = (order_desc == 1 ? "-" : "") + order_by;
          }
          const { page, itemsPerPage } = this.options;
          let pageNumber = reset ? 1 : page;
          this.loading = true;
          let state_id = this.filterState ? this.filterState.id : 0;
          let dealer_id = this.filterDealer ? this.filterDealer.dealer_id : 0;

          let res = await this.settlementRequest.search(
            dealer_id,
            state_id,
            this.date_from,
            order_by,
            pageNumber
          );
          if (this.$bRoot.errors) {
            throw "Error recuperando datos";
          }
          if (res) {
            this.items = res.data.results;
            this.serverItemsLength = res.data.count;
            this.page = pageNumber;
            this.pageCount = Math.ceil(res.data.count / itemsPerPage);
          }
        } catch (error) {
          if (!this.$bRoot.errors) {
            this.$bRoot.setError(error);
          }
        } finally {
          this.loading = false;
        }
      }
    },

    clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "stateAutocomplete":
          this.filterState = null;
          break;
        case "dealerAutocomplete":
          this.filterDealer = null;
          break;
      }
      this.readDataFromAPI(true);
    },

    stateSelected(state) {
      this.filterState = state;
      this.readDataFromAPI(true);
    },

    dealerSelected(item) {
      this.filterDealer = item;
      this.readDataFromAPI(true);
    },

    deleteItem(item) {
      this.$emit("deleteItem", item);
    },

    itemSelected(item, edit) {
      this.editMode = edit ? "edit" : "show";
      this.currentItem = Object.assign({}, item);
      if (this.enableEditing) {
        this.canEdit = item.can_edit;
        this.canRequestInvoicing = item.can_request_invoicing;
        this.canArchive = item.can_edit;
        this.canUnarchive = item.can_unarchive;
      } else {
        this.canEdit = false;
        this.canRequestInvoicing = false;
        this.canArchive = false;
        this.canUnarchive = false;
      }
      this.currentTab = 1;
    },

    async addNew() {
      this.currentItem = await this.settlementRequest.initialize(
        this.filterDealer
      );
      this.editMode = "new";
      this.currentTab = 1;
    },

    async loadDealers() {
      this.dealerItems = [];
      this.filterDealer = null;
      this.selectedDealer = null;
      let dealers = null;
      dealers = await this.$bRoot.searchAll(
        "/data/dealers_campaign_hierarchy/0",
        null,
        null
      );
      if (dealers) {
        this.dealerItems = dealers;
      }
    },

    sliceObj(obj) {
      var o = {},
        keys = [].slice.call(arguments, 1);
      // eslint-disable-next-line
      for (var i=0; i<keys.length; i++) {
        if (keys[i] in obj) o[keys[i]] = obj[keys[i]];
      }
      return o;
    },

    async DownloadSettlementRquests() {
      try {
        this.loading = true;
        let endpoint =
          "/data/orders_download/" +
          (this.filterCampaign ? this.filterCampaign.id.toString() : "0") +
          "/" +
          (this.filterCrop ? this.filterCrop.id.toString() : "0");

        // eslint-disable-next-line
        let raw = await this.$bRoot.search(endpoint, null, null, null, null);
        let datosWS = XLSX.utils.json_to_sheet(raw.data);
        let wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, datosWS, "pedidos");
        XLSX.writeFile(wb, "pedidos.xlsx");
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    },

    async cancel() {
      // eslint-disable-next-line
      if(this.editMode === 'show' || await this.$confirm("Confirme que desea abandonar la edición, los datos modificados se perderán")) {
        this.endEdit();
      }
    },

    edit() {
      if (this.currentItem && this.currentTab === 1) {
        this.editMode = "edit";
        this.$refs.itemEdit.mode = "edit";
        this.$refs.itemEdit.editing = true;
      }
    },

    async endEdit() {
      this.editMode = null;
      this.currentItem = null;
      this.error = null;
      this.currentTab = 0;
      await this.readDataFromAPI();
      this.onAction = false;
    },

    async save() {
      this.onAction = true;
      await this.$refs.itemEdit.save();
    },

    async actionCanceled() {
      this.onAction = false;
    },

    async requestInvoicing() {
      this.onAction = true;
      let state_code = this.currentItem.has_company_discount ? 20 : 40;
      await this.$refs.itemEdit.changeState(state_code);
    },

    async archive() {
      this.onAction = true;
      await this.$refs.itemEdit.changeState(100);
    },

    async unarchive() {
      this.onAction = true;
      await this.$refs.itemEdit.changeState(10);
    },

    getObservationText(item) {
      if (item.errors) {
        return item.errors;
      } else {
        return null;
      }
    },

    getPaginationSummary() {
      if (this.serverItemsLength === 0) {
        return "0-0 of 0";
      }

      const fromItem = (this.page - 1) * this.itemsPerPage + 1;
      const toItem = Math.min(this.page * this.itemsPerPage, this.serverItemsLength);
      return fromItem + "-" + toItem + " of " + this.serverItemsLength;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    dateFromEntered() {
      this.$refs["date_from"].save(this.date_from);
      this.date_from_formatted = this.formatDate(this.date_from);
    },

    viewDocumentItem(args) {
      window.open(args.invoice, "_blank", "noreferrer");
    }
  },

  async mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    // evaluete enableEditing
    this.enableEditing = true;
    if (
      (this.$bRoot.appInfo.commercial_person.commercial_person_type.level > 2 &&
        !this.$bRoot.appInfo.commercial_person.can_edit_orders)
    ) {
      this.enableEditing = false;
    }

    //states
    this.isLoadingState = true;
    let states = await this.settlementRequest.getStates();
    this.stateItems = states.data.results;
    this.isLoadingState = false;

    //date_from
    this.date_from_formatted = this.formatDate(this.date_from);

    this.mounting = false;
    await this.loadDealers();
    await this.readDataFromAPI();
  }
};
</script>

<style scoped>
.v-data-footer__select {
  display: none !important;
}
.v-data-footer:last-child {
  visibility: hidden !important;
}
.table-footer-prepend {
  height: 58px;
}
.table-footer-append {
  min-height: 58px;
}
.v-data-table {
  margin-top: -58px;
}
</style>
